
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"456","height":"682.667","viewBox":"0 0 342 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M263.5 1.4C261.1 2.5 23.4 228.9 5.7 247c-4.1 4.2-4.7 5.4-4.7 9 0 3.6.6 4.8 4.7 9 19.5 19.9 255.5 244.6 258.1 245.7 2.7 1.1 3.7 1.1 6.5-.1 1.8-.8 17.9-16.2 37-35.3 31.3-31.5 33.7-34.1 33.7-37.3 0-1.9-.8-4.7-1.8-6.1-.9-1.5-42.9-41.5-93.2-89-50.3-47.5-91.5-86.6-91.5-86.9 0-.3 41.2-39.4 91.5-86.9 50.3-47.5 92.3-87.5 93.2-89 1-1.4 1.8-4.2 1.8-6.1 0-3.2-2.4-5.8-33.7-37.3C279.1 8.4 269.4-.3 266.8 0c-.2.1-1.6.7-3.3 1.4z"}})])
          )
        }
      }
    